module.exports = __webpack_public_path__ + "static/media/bg17.fb4d84a2.jpg";